<template lang="pug">
.SingaSearchInput(:class="size")
	.search-right(v-if="searchString" @click="clearSearch()" :class="{'language-dropdown' : languageDropdown }")
		.esc {{ t('search.esc') }}
		SingaIcon(:icon="languageDropdown ? 'close-circle' : 'close-outline'" size="large")
	SingaField
		SingaInput(rounded :icon="languageDropdown ? '' : 'search-outline'" :placeholder="placeholderText" v-model="searchString" @keydown.esc="clearSearch()")
</template>

<script setup lang="ts">
import { useDebounceFn } from '@vueuse/core'

const searchString = ref('')

const props = defineProps({
	size: {
		type: String,
		default: ''
	},
	placeholderText: {
		type: String,
		default: ''
	},
	languageDropdown: {
		type: Boolean,
		default: false
	}
})

const { placeholderText } = toRefs(props)
const { t } = useI18n()

const emit = defineEmits(['filterChanged'])

const debouncedFn = useDebounceFn(() => {
	emit('filterChanged', searchString.value)
}, 1000)

watch(searchString, async (value) => {
	debouncedFn()
})

function clearSearch() {
	searchString.value = ''
}

onUnmounted(() => {
	clearSearch()
	emit('filterChanged', '')
})
</script>

<style lang="sass" scoped>
.SingaSearchInput
	width: 100%
	position: relative
	height: 48px
	&:not(:focus-within)
		.esc
			display: none
	:deep(input)
		border-color: transparent !important
		text-align: center
		@include font(basier, medium)
		padding-left: 48px !important
		height: 100%
	:deep(.control .icon)
		width: 32px
		height: 32px
		top: initial
		left: 6px !important
		.base-icon
			width: 32px
			height: 32px
.search-right
	display: flex
	align-items: center
	position: absolute
	right: 12px
	z-index: 1000
	height: 100%
	.icon
		color: $color-grey-50
	.esc
		background-color: $transparent-white-8
		color: $transparent-white-40
		padding: 4px 10px
		border-radius: $radius-default
		margin-right: $spacing-16
.field, .control
	height: 100%

@media (min-width: $tablet)
	.SingaSearchInput:not(.is-small)
		height: 56px

.language-dropdown
	&.search-right
		margin: 0 !important
		right: 0
		.esc
			display: none
	:deep(.iconify--ion)
		position: absolute
		top: 50%
		transform: translateY(-50%)
		width: 20px
		height: 20px
</style>

<style lang="sass" scoped>
.SingaSearchInput
	input
		border-color: transparent !important
		text-align: center
		@include font(basier, medium)
		padding-left: 48px !important
		height: 100%
	&.detail-search-input
		min-width: 344px
		:deep(.icon)
			width: $spacing-24
			height: $spacing-24
			left: $spacing-16 !important
		:deep(.search-right)
			z-index: 1
	.icon.is-left
		left: 12px !important

	@media (min-width: $tablet)
		input
			@include fontSize(m)
		&:not(.is-small)
			.icon.is-left
				left: 16px !important
</style>
